<template lang="pug">
  UiModal(
    v-model="isOpen"
    :title="displayTitle"
    :description="globalDialog.description"
    :actions="actions"
  )
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ModalGlobalDialog',
  computed: {
    ...mapState(['globalDialog']),
    isOpen: {
      get() {
        return this.globalDialog.isOpen
      },
      set(value) {
        if (!value) this.closeGlobalDialog()
      }
    },
    displayTitle() {
      return this.globalDialog.title || this.$t('modal.attention')
    },
    actions() {
      const list = [{ text: this.$t('close'), color: '#242D3B' }]
      const secondary = this.globalDialog.secondaryAction
      if (secondary) list.push({ text: secondary.text, color: '#FF5000', handler: secondary.handler })
      return list
    }
  },
  methods: {
    ...mapActions(['closeGlobalDialog'])
  }
}
</script>
